import { NextPage, GetServerSidePropsContext } from "next";
import { ENDPOINT_CONTENT_ID } from "lib/graphql/endpoints";
import { stringMinify } from "utils/StringUtils";
import getSettings from "utils/getSettings";
import { DynamicPageModel } from "models/dynamicPage";
import dynamic from "next/dynamic";

const HtmlComponent = dynamic(() => import("components/Html/Html"));

interface IDynamicPageProps {
    pageData: DynamicPageModel,
    settings: any,
}

const DynamicPage: NextPage<IDynamicPageProps> = ({ pageData, settings }) => {
    const {
        styles,
        scripts,
        titleHtml,
        javascriptContent,
    } = pageData;

    return (
        <>
            {styles && (
                <style jsx>{`${stringMinify(styles)}`}</style>
            )}
            {scripts &&
                <div id="dynamic-page-scripts" dangerouslySetInnerHTML={{ __html: stringMinify(scripts) }}></div>
            }
            {javascriptContent &&
                <div id="dynamic-page-javascriptContent" dangerouslySetInnerHTML={{ __html: stringMinify(javascriptContent) }}></div>
            }

            <section className="b-slider dynamic-page welcome-4 white-bg">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <HtmlComponent htmlValue={titleHtml} settings={settings} />
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export const getServerSideProps = async ({ query, res, req }: GetServerSidePropsContext) => {
    res.setHeader(
        'Cache-Control',
        `public, s-maxage=${process.env.CACHE_CONTROL_MAX}, stale-while-revalidate=${process.env.CACHE_CONTROL_MAX}`
    );
    const { dynamicpage } = query as any;

    const contentIds = [ENDPOINT_CONTENT_ID.DYNAMIC_PAGE_SETTINGS];
    const { settings, websiteContent } = await getSettings(req, contentIds);

    try {
        const content =
            websiteContent?.find(
                (item) => item?.key === ENDPOINT_CONTENT_ID.DYNAMIC_PAGE_SETTINGS
            ) || null;
        const json = JSON.parse(stringMinify(content?.value || ""));

        const pageData = json.pageList.find(
            (c: any) => c.url.toLowerCase() === dynamicpage.toLowerCase()
        );

        return {
            props: {
                titlePage: pageData.titlePage,
                friendlyUrl: pageData.friendlyUrl,
                keywords: pageData.keywords,
                content: pageData.metaDescription,
                pageData,
                settings,
                page: pageData.titlePage,
            },
        };
    } catch {
        return {
            notFound: true,
        };
    }
};

export default DynamicPage;
